import * as types from '../mutation-types'
import {MENU_TYPE, PERMISSION_KEY, PERMISSION_VALUE} from '../../common/constant'

const state = {
  main: {
    menus: [
      {
        type: 'item',
        isHeader: true,
        name: 'MENU'
      },
      {
        type: 'tree',
        icon: 'fa fa-database',
        name: PERMISSION_VALUE.DATA_MANAGEMENT,
        key: PERMISSION_KEY.DATA_MANAGEMENT,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Danh sách đơn hàng',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'OrderList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Import đơn hàng',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'ImportOrder'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Import dữ liệu đơn hàng',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'ImportOrderData'
            }
          }
        ]
      },
      {
        type: 'tree',
        icon: 'fa fa-user',
        name: PERMISSION_VALUE.USER_MANAGEMENT,
        key: PERMISSION_KEY.USER_MANAGEMENT,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Thiết lập doanh nghiệp',
            menuType: MENU_TYPE.SUPER_ADMIN,
            router: {
              name: 'CompanyList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Tổng quan',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'CompanyGeneral'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Thiết lập phòng ban',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'DepartmentList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Thiết lập chức vụ/quyền',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'RoleList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Thiết lập người dùng',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'UserList'
            }
          }
        ]
      },
      {
        type: 'item',
        icon: 'fa fa-building-o',
        name: PERMISSION_VALUE.PRODUCT_AND_WAREHOUSE,
        key: PERMISSION_KEY.PRODUCT_AND_WAREHOUSE,
        menuType: MENU_TYPE.NORMAL,
        router: {
          name: 'ProductList'
        }
      },
      {
        type: 'tree',
        icon: 'fa fa-bank',
        name: PERMISSION_VALUE.ACCOUNTING,
        key: PERMISSION_KEY.ACCOUNTING,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: PERMISSION_VALUE.ACCOUNTING_DETAIL,
            key: PERMISSION_KEY.ACCOUNTING_DETAIL,
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'AccountingDetailList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: PERMISSION_VALUE.ACCOUNTING_TOTAL,
            key: PERMISSION_KEY.ACCOUNTING_TOTAL,
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'AccountingList'
            }
          }
        ]
      },
      {
        type: 'item',
        icon: 'fa fa-building',
        key: PERMISSION_KEY.COMPANY_MANAGEMENT,
        menuType: MENU_TYPE.SUPER_ADMIN,
        name: PERMISSION_VALUE.COMPANY_MANAGEMENT,
        router: {
          name: 'CompanyList'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-id-card',
        name: PERMISSION_VALUE.ADMIN_MANAGEMENT,
        key: PERMISSION_KEY.ADMIN_MANAGEMENT,
        menuType: MENU_TYPE.SUPER_ADMIN,
        router: {
          name: 'AdminList'
        },
        items: []
      },
      {
        type: 'tree',
        icon: 'fa fa-phone',
        name: PERMISSION_VALUE.CALL_CENTER_LIST_MANAGEMENT,
        key: PERMISSION_KEY.CALL_CENTER_LIST_MANAGEMENT,
        menuType: MENU_TYPE.SUPER_ADMIN,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: PERMISSION_VALUE.CALL_CENTER_LIST_MANAGEMENT,
            key: PERMISSION_KEY.CALL_CENTER_LIST_MANAGEMENT,
            menuType: MENU_TYPE.SUPER_ADMIN,
            router: {
              name: 'CallCenterListManagement'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Cấu hình mức giá',
            key: 'Cấu hình mức giá',
            menuType: MENU_TYPE.SUPER_ADMIN,
            router: {
              name: 'Package'
            }
          }
        ]
      },
      {
        type: 'item',
        icon: 'fa fa-circle-o',
        name: PERMISSION_VALUE.PARAM_CONFIG,
        key: PERMISSION_KEY.PARAM_CONFIG,
        menuType: MENU_TYPE.SUPER_ADMIN,
        router: {
          name: 'ParamList'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-phone',
        name: PERMISSION_VALUE.CALL_CENTER_ABOUT,
        key: PERMISSION_KEY.CALL_CENTER_ABOUT,
        menuType: MENU_TYPE.ADMIN,
        router: {
          name: 'CallCenterIntro'
        },
        items: []
      },
      {
        type: 'tree',
        icon: 'fa fa-phone',
        name: PERMISSION_VALUE.CALL_CENTER_MANAGEMENT,
        key: PERMISSION_KEY.CALL_CENTER_MANAGEMENT,
        menuType: MENU_TYPE.ADMIN,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Quản lý Ext',
            menuType: MENU_TYPE.ADMIN,
            router: {
              name: 'ExtUserManagement'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Danh sách ghi âm',
            menuType: MENU_TYPE.ADMIN,
            router: {
              name: 'CallRecords'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Báo cáo tổng đài',
            menuType: MENU_TYPE.ADMIN,
            router: {
              name: 'CallReport'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Báo cáo đối soát',
            menuType: MENU_TYPE.ADMIN,
            router: {
              name: 'CdrReport'
            }
          }
        ]
      },
      {
        type: 'tree',
        icon: 'fa fa-phone-square',
        name: PERMISSION_VALUE.PHONE_NUMBER_TECHNICAL,
        key: PERMISSION_KEY.PHONE_NUMBER_TECHNICAL,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Quản lý số cho kĩ thuật',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'PhoneNumberManagementList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Quản lý sự cố số',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'PhoneNumberForTechList'
            }
          }
        ]
      },
      {
        type: 'tree',
        icon: 'fa fa-phone-square',
        name: PERMISSION_VALUE.PHONE_NUMBER_MANAGER,
        key: PERMISSION_KEY.PHONE_NUMBER_MANAGER,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Quản lý số',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'PhoneNumberManagementList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Import Số điện thoại',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'ImportPhoneNumber'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Tuỳ chỉnh',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'PhoneNumberSettings'
            }
          }
        ]
      },
      {
        type: 'tree',
        icon: 'fa fa-phone-square',
        name: PERMISSION_VALUE.PHONE_NUMBER_ADMIN,
        key: PERMISSION_KEY.PHONE_NUMBER_ADMIN,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Quản lý số',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'PhoneNumberManagementList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Quản lý sự cố số',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'PhoneNumberForTechList'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Import Số điện thoại',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'ImportPhoneNumber'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Tuỳ chỉnh',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'PhoneNumberSettings'
            }
          }
        ]
      },
      {
        type: 'tree',
        icon: 'fa fa-phone',
        name: PERMISSION_VALUE.USER_CALL_CENTER_MANAGEMENT,
        key: PERMISSION_KEY.USER_CALL_CENTER_MANAGEMENT,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Danh sách ghi âm',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'CallRecords'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Báo cáo tổng đài',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'CallReport'
            }
          },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Báo cáo đối soát',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'CdrReport'
            }
          }
        ]
      },
      {
        type: 'tree',
        icon: 'fa fa-share-alt',
        name: PERMISSION_VALUE.MARKETING,
        key: PERMISSION_KEY.MARKETING,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Đồng bộ Facebook',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'FacebookConnect'
            }
          }
        ]
      },
      {
        type: 'tree',
        icon: 'fa fa-bar-chart',
        name: PERMISSION_VALUE.REPORT,
        key: PERMISSION_KEY.REPORT,
        menuType: MENU_TYPE.NORMAL,
        items: [
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Báo cáo doanh số',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'ReportNewOrder'
            }
          },
          // {
          //   type: 'item',
          //   icon: 'fa fa-circle-o',
          //   name: 'Báo cáo doanh số định kì',
          //   menuType: MENU_TYPE.NORMAL,
          //   router: {
          //     name: 'ReportAnnualRevenue'
          //   }
          // },
          // {
          //   type: 'item',
          //   icon: 'fa fa-circle-o',
          //   name: 'Báo cáo nợ xấu',
          //   menuType: MENU_TYPE.NORMAL,
          //   router: {
          //     name: 'ReportBadDebt'
          //   }
          // },
          {
            type: 'item',
            icon: 'fa fa-circle-o',
            name: 'Báo cáo theo trạng thái',
            menuType: MENU_TYPE.NORMAL,
            router: {
              name: 'ReportOrderStatus'
            }
          }
        ]
      },
      {
        type: 'item',
        icon: 'fa fa-cogs',
        name: PERMISSION_VALUE.SYSTEM_CONFIGURATION,
        key: PERMISSION_KEY.SYSTEM_CONFIGURATION,
        menuType: MENU_TYPE.NORMAL,
        router: {
          name: 'SettingBoard'
        }
      }
    ],
    activeMenu: 'Dashboard'
  }
}

const mutations = {
  [types.CHANGE_MENU] (state, routerName) {
    state.main.activeMenu = routerName
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/menu.js